import { createSlice } from "@reduxjs/toolkit"

let initialState = {
  paymentSettings: {
  }
}

const UDStorage = window.localStorage.getItem('paymentSettings');
if(UDStorage)
  initialState = {paymentSettings: JSON.parse(UDStorage)};


export const paymentSettings = createSlice({
  name: 'paymentSettings',
  initialState,
  reducers: {
    setPaymentSettings: (state,action) => {
      const data = {...state.paymentSettings,...action.payload}
      state.paymentSettings = data;
      window.localStorage.setItem('paymentSettings',JSON.stringify(data))
    },
  }
})

export const {setPaymentSettings} = paymentSettings.actions;

export default paymentSettings.reducer;